import { render, staticRenderFns } from "./OldRascal.vue?vue&type=template&id=059dc96e&scoped=true&"
import script from "./OldRascal.vue?vue&type=script&lang=js&"
export * from "./OldRascal.vue?vue&type=script&lang=js&"
import style0 from "./OldRascal.vue?vue&type=style&index=0&id=059dc96e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059dc96e",
  null
  
)

export default component.exports